// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__0Cuie","notAvailableTournaments":"styles_notAvailableTournaments__1g9vp"};